import { IsRtmpURLValid } from '../../utils/rtmp';

function validateStreamKey(key) {
  return !(!key || /^\s*$/.test(key));
}

export default function ModalAddMultiUseRTMPChannel(
  mode,
  config,
  RTMPPushChannel,
  toaster,
  $rootScope,
  $uibModalInstance
) {
  'ngInject';

  // passed in via `resolve`
  this.mode = mode;
  this.config = angular.copy(config);
  this.useAuthentication = this.config.username && this.config.password;

  this.limits = $rootScope.ApiConfig.modelFieldLimits('rtmp_push_channel', 'maximum');

  this.cancel = () => $uibModalInstance.dismiss();
  this.submit = () => {
    if (
      !this.config.name ||
      !IsRtmpURLValid(this.config.stream_url) ||
      !validateStreamKey(this.config.stream_key)
    ) {
      alert('Please enter a valid name, stream URL, and stream key.');
      return;
    }
    if (!this.useAuthentication) {
      delete this.config.username;
      delete this.config.password;
    }
    this.submitting = true;

    RTMPPushChannel[this.mode == 'add' ? 'create' : 'update'](
      this.config,
      (r) => {
        $uibModalInstance.close(r);
      },
      (e) => {
        console.error(e);
        toaster.pop('warning', 'Unable to save RTMP configuration. Please refresh and try again.');
        this.submitting = false;
      }
    );
  };
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-add-multi-use-rtmp-channel.js